var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sub-page',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"description":_vm.description,"button-text":_vm.buttonText,"bg":_vm.bg,"bg2":_vm.bg2}})
}
var staticRenderFns = []

export { render, staticRenderFns }